import React from 'react';

interface IProps {
  name: string;
  type: 'multiple' | 'text' | 'checkbox' | 'single' | 'multiple-text' | 'customer' | 'select-tree';
  options?: any;
  action?: any;
  label?: string;
  value?: string;
  tagLabel?: string;
  format?: any;
  validationType?: 'email' | 'document';
  placeholder?: string;
  helperText?: string;
}

const Item: React.FC<IProps> = () => {
  return <span />;
};

export default Item;
